<div class="app-container">
  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
  <form [formGroup]="automaticOrdersSettingsForm" (ngSubmit)="updateData()" *ngIf="automaticOrdersSettings">
    <page-header [icon]="'fa-repeat'" [title]="'menu.automatic-orders'" [appendNoTranslationTitlePart]="''">
      <ng-container class="header-button">
        <btn
          [label]="'save'"
          [title]="'save' | translate"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-check'"
          [btnType]="'submit'"
          [isLoading]="loading"
          [spinnerClassesString]="'spinner-white'"
          [btnDisabled]="loading"
          data-cy="create-checkout"
        ></btn>
      </ng-container>
      <ng-container class="back-button">
        <btn
          [label]="'back'"
          [title]="'back' | translate"
          [isBackButton]="true"
          [classes]="['btn-third', 'float-right', 'mr-2']"
          [icon]="'far-arrow-left'"
          (onEvent)="triggerBackBtn()"
        ></btn>
      </ng-container>
    </page-header>

    <section class="content">
      <div class="card">
        <div class="row">
          <div class="col-12">
            <p class="font-weight-bold">{{ 'automatic-orders.automatizationLevel' | translate }}</p>
            <form-row-select
              [icon]="null"
              [model]="automaticOrdersSettings.automatizationLevel"
              (modelChange)="automaticOrdersSettings.automatizationLevel = $event"
              [options]="automatizationLevelOptions"
              [dataCyAttribute]="'select-automaticOrdersSettings.automatizationLevel'"
            ></form-row-select>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="automaticOrdersSettings.automatizationLevel !== 'none'">
        <div class="col-sm-6">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="row">
                  <div class="col-12">
                    <p class="font-weight-bold">{{ 'automatic-orders.frequency.heading' | translate }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <form-row-select
                      [label]="'automatic-orders.frequency'"
                      [icon]="null"
                      [model]="automaticOrdersSettings.frequency"
                      (modelChange)="automaticOrdersSettings.frequency = $event"
                      [options]="frequencyOptions"
                      [dataCyAttribute]="'select-automaticOrdersSettings.frequency'"
                    ></form-row-select>
                  </div>
                  <div class="col-sm-6">
                    <form-row-select
                      *ngIf="automaticOrdersSettings.frequency !== 'monthly'"
                      [label]="'automatic-orders.weekDay'"
                      [icon]="null"
                      [model]="automaticOrdersSettings.weekDay"
                      (modelChange)="automaticOrdersSettings.weekDay = $event"
                      [options]="weekDayOptions"
                      [dataCyAttribute]="'select-automaticOrdersSettings.weekDay'"
                    ></form-row-select>
                    <form-row-input
                      *ngIf="automaticOrdersSettings.frequency === 'monthly'"
                      [label]="'automatic-orders.monthDay'"
                      [inputType]="'number'"
                      [numberMin]="1"
                      [numberMax]="28"
                      [formGroup]="automaticOrdersSettingsForm"
                      formControlName="monthDay"
                      [required]="
                        automaticOrdersSettingsForm.get('monthDay').errors !== null &&
                        automaticOrdersSettingsForm.get('monthDay').errors.required
                      "
                      [requiredCssClass]="submitted && formControls.monthDay.errors"
                      [noMarginBottom]="true"
                      data-cy="automatic-orders.monthDay"
                    ></form-row-input>
                  </div>
                  <div class="ml-2 font-weight-light text-sm font-italic">
                    {{ 'automatic-orders.time-note' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <p class="font-weight-bold">{{ 'automatic-orders.notificationEmail' | translate }}</p>
                <form-row-input
                  [formGroup]="automaticOrdersSettingsForm"
                  formControlName="notificationEmail"
                  [required]="
                    automaticOrdersSettingsForm.get('notificationEmail').errors !== null &&
                    automaticOrdersSettingsForm.get('notificationEmail').errors.required
                  "
                  [requiredCssClass]="submitted && formControls.notificationEmail.errors"
                  [noMarginBottom]="true"
                  data-cy="automatic-orders.notificationEmail"
                ></form-row-input>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-12">
              <div class="card ml-sm-2 mt-3 mt-sm-0">
                <p class="font-weight-bold">{{ 'automatic-orders.depots' | translate }}</p>
                <div class="form-group">
                  <div *ngFor="let depot of depots">
                    <div class="d-flex align-items-center flex-wrap">
                      <form-row-toggle
                        [label]="depot.name"
                        class="mr-3 mb-2"
                        style="min-width: 200px"
                        [model]="isChosenDepot(depot)"
                        (modelChange)="toggleDepot(depot, $event)"
                      ></form-row-toggle>
                      <form-row-select
                        class="mb-2"
                        style="flex: 1 1 300px"
                        [maxWidthPx]="600"
                        [label]="'purchaseOrder.shippingAddress'"
                        [options]="addresses"
                        [model]="!isChosenDepot(depot) ? null : depotAddresses[depot.id]"
                        (modelChange)="updateDepotAddress(depot.id, $event)"
                        [isSelectDisabled]="!isChosenDepot(depot)"
                      ></form-row-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </form>
</div>
